import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const DescriptionContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.lines.secondary};
  margin: ${layout.spacing.xSmall};
  margin-top: ${layout.spacing.medium};
  margin-bottom: ${layout.spacing.medium};
  padding: ${layout.spacing.medium} 0 0 0;
`;

export const DescriptionTitle = styled.h2`
  font-weight: normal;
  margin: 0 0 ${layout.spacing.xSmall} 0;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.text.tertiary};
  margin: 0;
  max-width: 600px;
`;
